var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_793_1354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9L8.95213 13.3812C8.81044 13.5229 8.7396 13.5937 8.69302 13.6808C8.64644 13.7678 8.62679 13.866 8.58749 14.0625L8.09806 16.5097C8.05371 16.7315 8.03154 16.8423 8.09461 16.9054C8.15768 16.9685 8.26855 16.9463 8.49029 16.9019L8.49029 16.9019L10.9375 16.4125C11.134 16.3732 11.2322 16.3536 11.3192 16.307C11.4063 16.2604 11.4771 16.1896 11.6188 16.0479L16 11.6667L13.3333 9Z",
    stroke: "currentColor",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90775 13.3853L8.90775 13.3853C8.90754 13.3855 8.90734 13.3857 8.90713 13.3859C8.89896 13.3941 8.89071 13.4023 8.88242 13.4106C8.77825 13.5143 8.66625 13.6259 8.58691 13.766C8.50756 13.9062 8.46953 14.0596 8.43415 14.2023C8.43126 14.214 8.42839 14.2255 8.42552 14.237L7.98317 16.0064C7.98142 16.0134 7.97964 16.0205 7.97783 16.0277C7.95261 16.1283 7.92169 16.2515 7.91126 16.3581C7.89948 16.4786 7.89842 16.7163 8.09115 16.909C8.28388 17.1017 8.52155 17.1007 8.64203 17.0889C8.74866 17.0785 8.87189 17.0476 8.97242 17.0223C8.97964 17.0205 8.98675 17.0187 8.99373 17.017L10.7631 16.5746C10.7746 16.5718 10.7862 16.5689 10.7979 16.566C10.9406 16.5306 11.094 16.4926 11.2341 16.4133C11.3743 16.3339 11.4858 16.2219 11.5896 16.1177C11.5981 16.1092 11.6065 16.1008 11.6149 16.0924L16.4109 11.2964L16.432 11.2753C16.6361 11.0713 16.8231 10.8842 16.9549 10.7116C17.0999 10.5215 17.224 10.2914 17.224 10C17.224 9.70865 17.0999 9.47852 16.9549 9.28842C16.8232 9.11579 16.6361 8.92875 16.432 8.72474C16.425 8.71773 16.418 8.71069 16.4109 8.70364L16.2965 8.58926C16.2895 8.5822 16.2824 8.57517 16.2754 8.56816C16.0714 8.3641 15.8844 8.17701 15.7117 8.0453C15.5216 7.90025 15.2915 7.77614 15.0002 7.77614C14.7088 7.77614 14.4787 7.90025 14.2886 8.0453C14.1159 8.17701 13.9289 8.3641 13.7249 8.56816C13.7179 8.57517 13.7109 8.5822 13.7038 8.58926L8.90775 13.3853Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 9L16.0002 11.6667",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_1354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.517286424302455b9bc3e9ec3564f0b2.svg";
export { ForwardRef as ReactComponent };